import React, { lazy } from "react";
import { useNavigate } from "react-router-dom";
import "./MainComp.css";
import Faq from "../faq/Faq";
import Hero from "../HeroSection/HeroSection";
import OurServices from "../../utils/images/seoimages/our-services.webp";
import CreateWebsite from "../../utils/images/seoimages/skapa-hemsida.webp";
import WorkWithUs from "../../utils/images/seoimages/chooseUs.webp";
import OurVision from "../../utils/images/seoimages/vision.webp";
import ServiceBoxes from "./ServiceBoxes";

const MainComp = ({ subTitle5, query, city, formTitle, h1 }) => {
  const Divider = lazy(() => import("./Divider"));
  const Arbetsprocessen = lazy(() => import("../Arbetsprocessen"));
  const MainUseComp = lazy(() => import("./MainUseComp"));
  const LogoAnimation = lazy(() => import("./LogoAnimation"));
  const Helhetslosning = lazy(() => import("../completeMarketingSolutions"));
  const ourservices = OurServices;
  const createwebsite = CreateWebsite;
  const workWithUs = WorkWithUs;
  const ourvision = OurVision;
  const navigate = useNavigate();

  return (
    <section className="root">
      <Hero h1={h1} />
      <ServiceBoxes />
      <MainUseComp formTitle={formTitle} />
      <Arbetsprocessen />
      <LogoAnimation />
      <section className="content-new-container">
        <h2 className="mainComp-h2">
          Från <span className="mainComp-h2-query">{query}</span> till
          Löpande Support
        </h2>
        <div className="content-box-container">
          <div>
            <img className="content-img" src={ourservices} alt="Description" />
            <h3>{subTitle5}</h3>
            <p>
              Behöver du hjälp med att Analys , Strategi, Uppföljning och löpande support vi erbjuda våra kunder en oslagbar fördel när det gäller sökmotoroptimering (SEO) och digital-marknadsföring.
            </p>
            <button
              className="content-button"
              onClick={() => navigate("/analys")}
            >
              Läs mer
            </button>
          </div>

          <div>
            <img
              className="content-img"
              src={createwebsite}
              alt="Description"
            />
            <h3>Skapande av Hemsida</h3>
            <p>
              Att ta hand om ett Hemsida Vi skapar en anpassad hemsida för ditt företag som speglar din företagsidentitet och inkluderar all nödvändig information om dina tjänster.
            </p>
            <button
              className="content-button"
              onClick={() => navigate("/skapande")}
            >
              Läs mer
            </button>
          </div>

          <div id="wecando">
            <img className="content-img" src={workWithUs} alt="Description" />
            <h3>Varför Välja Oss?</h3>
            <p>
              Unikt Nätverk av Domäner: Med vårt omfattande nätverk får ditt företag en betydande SEO-fördel. Vi anpassar våra tjänster efter dina specifika behov och mål. Expertis och Erfarenhet: Vårt team har den erfarenhet och kunskap som krävs för att hjälpa ditt företag att lyckas online.
            </p>
            <button
              className="content-button"
              onClick={() => navigate("/om-oss")}
            >
              Läs mer
            </button>
          </div>

          <div>
            <img className="content-img" src={ourvision} alt="Description" />
            <h3>Vår Vision</h3>
            <p>
              Vår vision är att stärka lokala företag genom att ge dem de verktyg och resurser de behöver för att nå sin fulla potential online. Vi tror att varje företag, oavsett storlek eller bransch, förtjänar att synas och höras i den digitala världen. hjälper vi våra kunder att bli mer synliga för sina potentiella kunder och att växa sin verksamhet.
            </p>
            <button
              className="content-button"
              onClick={() => navigate("/kontinuerlig")}
            >
              Läs mer
            </button>
          </div>
        </div>
      </section>
      <Helhetslosning />
    </section>
  );
};

export default MainComp;
